import { styled } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";

export const IgniteMainWrapper = styled(Box)({
  width: "100%",
});

export const BannerSection = styled(Box)({
  width: "100%",
  backgroundImage: `url(${process.env.PUBLIC_URL}/Assets/Home/Ignite-banner3.png)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  minHeight: "260px",
});

export const BannerContent = styled(Box)({
  padding: "60px 5%",
  width: "70%",
});

export const BannerTitle = styled(Typography)({
  color: "#FFFFFF",
  fontSize: "34px",
  fontWeight: 600,
});

export const BannerSubTitle = styled(Typography)({
  color: "#FFFFFF",
  paddingTop: "15px",
  fontSize: "18px",
  fontWeight: 500,
});

export const TeamWrapper = styled(Box)({
  width: "90%",
  margin: "auto",
  padding: "20px 0",
});

export const TeamHeader = styled(Box)({
  marginBottom: "35px",
});

export const TeamTitle = styled(Typography)({
  fontSize: "22px",
  fontWeight: 600,
  color: "#2B2B2B",
  marginBottom: "12px",
});

export const TeamSubtitle = styled(Typography)({
  fontSize: "15px",
  lineHeight: 1.6,
  color: "#555555",
});

export const TeamGrid = styled(Box)({
  margin: "auto",
  width: "65%",
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  justifyItems: "center",
});

export const TeamCard = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const TeamImageWrapper = styled(Box)({
  width: "200px",
  height: "230px",
 // backgroundColor: "#3A3A3A",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const TeamImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

export const TeamInfoBox = styled(Box)({
  width: "280px",
  //border: "2px solid #A100FF",
  padding: "6px 10px",
  marginTop: "-6px",
  backgroundColor: "#FFFFFF",
  textAlign: "center",
});

export const TeamName = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  color: "#000000",
  marginBottom: "4px",
});

export const TeamRole = styled(Typography)({
  fontSize: "14px",
  color: "#555555",
});

export const CoreTeamWrapper = styled(Box)({
  margin: "auto",
  padding: "30px 0",
});

export const CoreTeamHeader = styled(Box)({
  marginBottom: "20px",
});

export const CoreTeamTitle = styled(Typography)({
  fontSize: "22px",
  fontWeight: 600,
  marginBottom: "6px",
});

export const CoreTeamSubtitle = styled(Typography)({
  fontSize: "15px",
  color: "#555555",
});

export const CoreTeamGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(6, 1fr)",
  gap: "56px 24px",
  justifyItems: "center",
  marginTop: "20px",
});

export const CoreTeamCard = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
});

export const AvatarRing = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
});

export const AvatarImage = styled("img")({
  width: "110px",
  height: "110px",
  objectFit: "cover",
});

export const MemberName = styled(Typography)({
  fontSize: "15px",
  fontWeight: 600,
  marginTop: "12px",
});

export const MemberRole = styled(Typography)({
  fontSize: "13px",
  color: "#777777",
  marginTop: "2px",
});